module.exports = __webpack_public_path__ + "static/media/logoskoly.a2e3e607.png";